<script lang="ts">
  import Portal from "svelte-portal"
  import DirectFileUpload from '../shared/DirectFileUpload.svelte'
  import ImagePreview from './ImagePreview.svelte'
  import { onDestroy, onMount } from 'svelte'

  // TODO: handle edit mode, modifying of existing images
  let {
    message: initialMessage,
  } = $props()

  const message = JSON.parse(initialMessage)
  let images = $state([])

  onMount(() => {
    // set up array of image data for edit mode
    if (message.images_attachments) {
      images = message.images_attachments.map((image) => ({
        id: image.id,
        name: image.blob.filename,
        data: image.thumb_url,
      }))
    }
  })

  // @param image: Base64 string from FileReader.readAsDataURL
  function imageChanged(image, meta) {
    App.emit('messages-modal.busy', true)

    // if meta.totalFiles !== images.length, redefine images array
    if (meta.totalFiles !== images.length) {
      images = Array(meta.totalFiles)
    }
    images[meta.currentFile - 1] = {
      name: meta.file.name,
      data: image,
    }
  }

  function uploadChanged(upload, meta) {
    console.log('should be enabling upload button')
    App.emit('messages-modal.busy', false)

    if (upload) {
      images[meta.currentFile - 1].signedId = upload.signed_id
    } else {
      // TODO remove or show error?
    }
  }

  function uploadError(error, meta) {
    // handle error
  }

  // If image is persisted, set it to be purged
  // and do not remove from array?  because we need the _delete form field
  // else just remove from array
  function onRemove(image) {
    console.log('onRemove', image)
    if (image.id) {
      image.remove = true
      const index = images.findIndex(i => i.id === image.id);
      console.log('index', index)
      const newImages = [...images]
      if (index !== -1) {
        newImages[index] = image;
      }
      images = newImages
      return
    }
    images = images.filter(i => i !== image)
  }

</script>

<Portal target="#message-upload-images-button-portal">
  <label class="ttip-item btn btn-white btn-lg btn-square btn-new-msg-image" for="msg-images-field">
    <span class="ttip">
      Upload an Image
    </span>
  </label>
</Portal>

<div class="message-images-preview-container">
  {#each images.filter(i => i) as image}
    <ImagePreview
      id={image.id}
      name={image.name}
      src={image.data}
      signedId={image.signedId}
      remove={image.remove}
      onRemove={() => onRemove(image)}
    />
  {/each}
</div>

<DirectFileUpload
  id="msg-images-field"
  class="message-images-file-field"
  multiple={true}
  {imageChanged}
  {uploadChanged}
  {uploadError}
/>
